import React from 'react';
import { func_cookieSetting, getObjectPropertyValue, isDateValid, isNumberOrStringValid, isNumberValid, isStringTrimNotEmpty, reformatNumberWithCommas, func_datetime, isNotNullUndefined } from 'functions';

export function useTableColumns() {

    function getColumn_storeCode() {
        let columnClassName = "table__column-store-code";

        return {
            headerCellClassName: columnClassName + " ",
            Header: "Store Code",
            id: "storeCode",
            accessor: "StoreCode",
            bodyCellClassName: columnClassName + " ",
            Cell: (props) => {
                let value = props?.cell?.value;
                let value_formatted = isStringTrimNotEmpty(value)? value: "-";
    
                return (
                    <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
                );
            },
            width: 200
        }
    }

    function getColumn_storeName() {
        let columnClassName = "table__column-store-name";

        return {
            headerCellClassName: columnClassName + " ",
            Header: "Store Name",
            id: "storeName",
            accessor: "StoreName",
            bodyCellClassName: columnClassName + " ",
            Cell: (props) => {
                let value = props?.cell?.value;
                let value_formatted = isStringTrimNotEmpty(value)? value: "-";
    
                return (
                    <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
                );
            },
            width: 400
        }
    }

    function getColumn_address1() {
        let columnClassName = "table__column-address";

        return {
            headerCellClassName: columnClassName + " ",
            Header: "Address 1",
            id: "address1",
            accessor: "Address1",
            bodyCellClassName: columnClassName + " ",
            Cell: (props) => {
                let value = props?.cell?.value;
                let value_formatted = isStringTrimNotEmpty(value)? value: "-";
    
                return (
                    <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
                );
            },
            width: 300
        }
    }

    function getColumn_address2() {
        let columnClassName = "table__column-address";

        return {
            headerCellClassName: columnClassName + " ",
            Header: "Address 2",
            id: "address2",
            accessor: "Address2",
            bodyCellClassName: columnClassName + " ",
            Cell: (props) => {
                let value = props?.cell?.value;
                let value_formatted = isStringTrimNotEmpty(value)? value: "-";
    
                return (
                    <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
                );
            },
            width: 300
        }
    }

    function getColumn_postCode() {
        let columnClassName = "table__column-postcode";

        return {
            headerCellClassName: columnClassName + " ",
            Header: "Post Code",
            id: "postCode",
            accessor: "PostCode",
            bodyCellClassName: columnClassName + " ",
            Cell: (props) => {
                let value = props?.cell?.value;
                let value_formatted = isStringTrimNotEmpty(value)? value: "-";
    
                return (
                    <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
                );
            },
            width: 150
        }
    }

    function getColumn_city() {
        let columnClassName = "table__column-city";

        return {
            headerCellClassName: columnClassName + " ",
            Header: "City",
            id: "city",
            accessor: "City",
            bodyCellClassName: columnClassName + " ",
            Cell: (props) => {
                let value = props?.cell?.value;
                let value_formatted = isStringTrimNotEmpty(value)? value: "-";
    
                return (
                    <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
                );
            },
            width: 200
        }
    }

    function getColumn_state() {
        let columnClassName = "table__column-state";

        return {
            headerCellClassName: columnClassName + " ",
            Header: "State",
            id: "state",
            accessor: "State",
            bodyCellClassName: columnClassName + " ",
            Cell: (props) => {
                let value = props?.cell?.value;
                let value_formatted = isStringTrimNotEmpty(value)? value: "-";
    
                return (
                    <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
                );
            },
            width: 200
        }
    }

    function getColumn_activeDate() {
        let columnClassName = "table__column-active-date";

        return {
            headerCellClassName: columnClassName + " ",
            Header: "Active Date",
            id: "activeDate",
            accessor: "Active_date",
            bodyCellClassName: columnClassName + " ",
            Cell: (props) => {
                let value = props?.cell?.value;
                let value_formatted = isStringTrimNotEmpty(value) ? value : "-";
    
                return (
                    <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
                );
            },
            width: 150
        }
    }

    function getColumn_operationHours() {
        let columnClassName = "table__column-operation-hours";

        return {
            headerCellClassName: columnClassName + " ",
            Header: "Operation Hours",
            id: "operationHours",
            accessor: "Operation_hours",
            bodyCellClassName: columnClassName + " ",
            Cell: (props) => {
                let value = props?.cell?.value;
                let value_formatted = isStringTrimNotEmpty(value)? value: "-";
    
                return (
                    <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
                );
            },
            width: 200
        }
    }

    return [
        getColumn_storeCode(),
        getColumn_storeName(),
        getColumn_address1(),
        getColumn_address2(),
        getColumn_postCode(),
        getColumn_city(),
        getColumn_state(),
        getColumn_activeDate(),
        getColumn_operationHours(),
    ]
}